import * as React from 'react';

const TriangleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width={19}
        height={19}
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit={2}
        clipRule="evenodd"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="nonzero"
            stroke="currentColor"
            d="m2.095 19.882 9.248-16.5a.753.753 0 0 1 1.313 0l9.248 16.5a.75.75 0 0 1-.656 1.116H2.752a.75.75 0 0 1-.657-1.116zm1.935-.384h15.939l-7.97-14.22z"
        />
    </svg>
);
export default TriangleIcon;
